import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import DrawerContent from "./DrawerContent";
import { useNavigate } from "react-router-dom";
import { store } from "../../redux/store";
import { checkToken, logout } from "../../service/utenti";
import LoadingView from "../LoadingView";

const drawerWidth = 240;

type Props = {
    children: JSX.Element,
};
  

const ProtectedPage = ({ children }: Props) => {

  const { user } = store.getState(); 
  const navigate = useNavigate(); 

  const [mobileOpen, setMobileOpen] = React.useState<boolean>(false);
  const [isLoading, setIsLoading] = React.useState<boolean>(true); 


  React.useEffect(() => {

    tokenCheck(); 

  }, [])

  const tokenCheck = async () => {

    if(!user.token) {

      return navigate("/login"); 
  
    }
  
    try {

      await checkToken(user.token); 
        
      setIsLoading(false); 

    } catch(e) {

      logout().then(() => {

        return navigate("/login"); 

      })

    }

  }

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const container = window !== undefined ? () => window.document.body : undefined;

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>
          <img src={require("../../assets/images/logo.png")} style={{width:30, marginRight:20}} />
          <Typography variant="h6" noWrap component="div">
            Appello
          </Typography>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, 
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          <DrawerContent handleDrawerToggle={handleDrawerToggle} />
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
          open
        >
          <DrawerContent />
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 1,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
        }}
      >
        <Toolbar />
        {isLoading === true ? (

          <LoadingView />

        ) : children}
      </Box>
    </Box>
  );
};

export default ProtectedPage;
